/** Seitengröße für paginierte Listen, wenn keine Stufe greift */
export const DEFAULT_PAGE_SIZE = 25;

/**
 * Seitengrößen nach Viewport-Höhe, absteigend geordnet. Die erste passende
 * Stufe gewinnt.
 */
export const PAGE_SIZE_TIERS: ReadonlyArray<{
  minHeight: number;
  pageSize: number;
}> = [
  { minHeight: 1200, pageSize: 50 },
  { minHeight: 900, pageSize: 35 },
];

/**
 * Ermittelt die Seitengröße für paginierte Listen anhand der Viewport-Höhe.
 * Seiten, die mit einem Cursor weiterblättern, fragen den Wert einmal beim
 * Betreten ab und behalten ihn, damit sich die Seitenzuordnung während der
 * Nutzung nicht verschiebt.
 * @returns die Anzahl der Items pro Seite
 */
export function resolvePageSize(): number {
  const tier = PAGE_SIZE_TIERS.find(
    ({ minHeight }) =>
      window.matchMedia(`(min-height: ${minHeight}px)`).matches,
  );
  return tier ? tier.pageSize : DEFAULT_PAGE_SIZE;
}
